<script setup lang="ts">
import { RevolugoVueTermsAndConditions } from '@revolugo/elements-vue3'
</script>

<template>
  <footer class="p-0 w-full">
    <RevolugoVueTermsAndConditions class="w-full" />
  </footer>
</template>
